import React from 'react';
import {
  IInfoPopupStyleProps,
  InfoPopupContentStyled,
  InfoPopupInfoTextStyled,
  InfoPopupStyled,
} from './Popup.styled';
import { PopupActions, PopupProps } from 'reactjs-popup/dist/types';
import { FaInfoCircle } from 'react-icons/fa';
import { useCommonTranslation } from '../../hooks/i18n/useCommonTranslation';
import { usePopupAriaAttributes } from './Popup.hooks';

export type IInfoPopupInfoText = {
  infoText?: string;
  /**
   * Used for accessibility, should describe the purpose of the dialog.
   * If not provided, it will default to the title.
   * If neither title nor ariaLabel is provided, it will default to
   * 'popup-default-aria-label' translation.
   */
  ariaLabel?: string;
  open?: boolean;
};

type ITablePopupProps = IInfoPopupInfoText &
  PopupProps &
  React.RefAttributes<PopupActions> &
  IInfoPopupStyleProps;

export const Popup: React.FunctionComponent<ITablePopupProps> = ({
  infoText,
  ariaLabel,
  children,
  open = true,
  size = 'large',
  className,
  ...rest
}) => {
  const { t } = useCommonTranslation();
  const { popupClassName } = usePopupAriaAttributes({
    open,
    ariaLabel: ariaLabel ?? infoText ?? t('popup-default-aria-label'),
  });

  return (
    <InfoPopupStyled
      open={open}
      size={size}
      {...rest}
      className={[popupClassName, className].filter(Boolean).join(' ')}
    >
      {infoText && (
        <InfoPopupInfoTextStyled>
          <FaInfoCircle
            style={{
              marginRight: 'var(--s3)',
            }}
          />
          {infoText}
        </InfoPopupInfoTextStyled>
      )}
      <InfoPopupContentStyled size={size}>{children}</InfoPopupContentStyled>
    </InfoPopupStyled>
  );
};
